function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './RectangularCards.css';
import React from 'react';
import { EGeneralCardsIconTypes } from '../GeneralCardIconCards';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { get } from '../../../utils';
import ScrollAnimation from 'react-animate-on-scroll';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink';
import { isNotNil } from '../../../utils/IsNil';
import { tealiumMergeClickNewData, tealiumClickFunc } from '../../../utils/tealium';
import { convertToAnalyticObject } from '../../../utils/analytics';
var Cards = function Cards(_ref) {
  var item = _ref.item,
    params = _ref.params,
    eventsAnalytics = _ref.eventsAnalytics;
  var cardIconSrc = get(item, 'cardIcon.jss.value.src');
  var svgIcon = get(item, 'cardIconCode.jss.value');
  var cardIconAlt = get(item, 'cardIcon.jss.value.alt');
  var hasTitle = Boolean(get(item, 'title.jss.value'));
  var cardTitle = get(item, 'title.jss.value');
  var hasDescription = Boolean(get(item, 'description.jss.value'));
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription) && /*#__PURE__*/React.createElement("div", {
    className: "card--item__icon",
    "data-cy": "general-card-icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-box theme-contrast"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iconCircle"
  }, isNotNil(svgIcon) && svgIcon.includes("svg") ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: svgIcon
    },
    className: "h__icon"
  }) : /*#__PURE__*/React.createElement("img", {
    className: "h__icon",
    src: BASE_URL + cardIconSrc,
    alt: cardIconAlt
  })), /*#__PURE__*/React.createElement("div", {
    className: "titleDescription"
  }, hasTitle ? item.ctaLink.jss.value.href ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "cardTitleLink",
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
    },
    href: item.ctaLink.jss.value.href
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  })) : /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  }) : null, hasDescription ? item.ctaLink.jss.value.href ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "cardDescriptionLink",
    href: item.ctaLink.jss.value.href
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  })) : /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  }) : null))));
};
var RectangularCards = function RectangularCards(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var defaultCardsHasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var childrenItems = get(fields, 'data.item.children', []);
  var items = childrenItems.length ? childrenItems.filter(function (item) {
    return item.title && item.description;
  }) : [];
  var classItemsContainerMap = {
    2: "twoItemsContainer",
    3: "threeItemsContainer",
    4: "fourItemsContainer"
  };
  var classItemWidthMap = {
    2: "twoItemWidth",
    3: "threeItemWidth",
    4: "fourItemWidth"
  };
  var cardsProps = {
    params: {
      eventCat: params.eventCat,
      eventName: params.eventName,
      eventAct: params.eventAct,
      ColorHex: params.ColorHex,
      BackgroundColorHex: params.BackgroundColorHex
    }
  };
  if (items.length >= 5) {
    console.warn("provided ".concat(items.length, " items, but max count is 4 in ").concat(EGeneralCardsIconTypes.Rectangular, " type"));
  }
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderItems04 = function renderItems04() {
    if (items.length <= 1) {
      console.warn("provided ".concat(items.length, " cards but requires 2 or more"));
      return;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: items.length < 5 ? classItemsContainerMap[items.length] : classItemsContainerMap[4]
    }, items.slice(0, 4).map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "itemWidth ".concat(items.length < 5 ? classItemWidthMap[items.length] : classItemWidthMap[4]),
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        key: item.id
      }, /*#__PURE__*/React.createElement(Cards, _extends({}, cardsProps, {
        item: item,
        eventsAnalytics: eventsAnalytics
      })));
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: "M07_rectangular"
  }, defaultCardsHasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, renderItems04());
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    className = _ref3.className,
    style = _ref3.style;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var generalItemsContainer = "\n  display: flex;\n  gap: 10px 20px;\n";
var commonStyles = "ccn61pw";
var ltrStyles = "lvjdw7u";
var rtlStyles = "r16fec8a";
export { RectangularCards };